export default {
  path: '/ratio-quota',
  meta: {
    title: '云仓配额明细',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-quota`),
}



// WEBPACK FOOTER //
// ./src/views/RatioQuota/router.js